import type { InspectionType } from '@/common/inspection';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type UpdateInspectionSuccessResponseType = InspectionType;

export async function updateInspection(
	assetId: string,
	inspectionId: string,
	payload: Omit<InspectionType, 'id'>,
): Promise<UpdateInspectionSuccessResponseType | null> {
	const response = await axios.patch(`${API_URLS.INSPECTION.INDEX(assetId)}/${inspectionId}`, payload);
	return getResponse<UpdateInspectionSuccessResponseType>(response.data);
}
